// this is an autogenerated file from App/ChooseLocation/Support/mutation-login-xid.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_ChooseLocation_Support(
  $xid: String!
  $ref: String
  $for_user_id: uuid
  $mfa_token: String
) {
  vaxiom_users_login_xid(
    xid: $xid
    ref: $ref
    for_user_id: $for_user_id
    mfa_token: $mfa_token
  ) {
    status
    access_token: jwt_token
    refresh_token
    inactivity_timeout
  }
}

`